import api, { formatApiErrorDetail } from "@/lib/api";
import { copyFromApi } from "@/lib/copyLink";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Link2 } from "lucide-react";

export const CopyAccessButton = ({ r, onCopied, label = false }) => {
  const copy = async () => {
    let at = "";
    try {
      await copyFromApi(async () => {
        const { data } = await api.post(`/admin/users/${r.id}/access-link`);
        at = data.invited_at;
        return data.url;
      });
      toast.success(`Lien d'accès de ${r.name || r.email} copié (valable 7 jours) : collez-le dans un SMS ou WhatsApp`);
      onCopied?.(r.id, at);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Impossible de copier le lien"); }
  };
  if (label) {
    return (
      <Button variant="outline" className="gap-2" onClick={copy} data-testid="reseller-form-copy-access">
        <Link2 className="w-4 h-4" /> Copier le lien d'accès
      </Button>
    );
  }
  return (
    <Button size="icon" variant="ghost" onClick={copy} title={`Copier le lien d'accès de ${r.email}`} data-testid={`copy-access-${r.email}`}>
      <Link2 className="w-4 h-4" />
    </Button>
  );
};
